<script lang="ts">
  import type { DropdownListOption } from '$shared/components/types';
  import { DropdownListType } from './DropdownListProps';
  import List from './partial/List.svelte';
  import SearchableList from './partial/SearchableList.svelte';

  interface Props {
    list?: CommonList[];
    maxheight?: boolean;
    option?: DropdownListOption;
    onclick?: (item: CommonList) => void;
    oncreate?: (value: string) => void;
    oninputcreate?: (value: string) => void;
    onhighlight?: (optionId?: string) => void;
    listId?: string;
  }

  let {
    list = [],
    maxheight = false,
    option = {},
    onclick,
    oncreate,
    oninputcreate,
    onhighlight,
    listId
  }: Props = $props();

  let searchableListElement: SearchableList | undefined = $state();
  let plainListElement: List | undefined = $state();

  export const focus = (): void => {
    searchableListElement?.focus();
  };

  /** Returns true when the key was consumed by the rendered list. */
  export const handleKeyDown = (e: KeyboardEvent): boolean =>
    (searchableListElement ?? plainListElement)?.handleKeyDown(e) ?? false;

  export const reset = (): void => {
    (searchableListElement ?? plainListElement)?.reset();
  };
</script>

<div class="comp-dropdown-list" class:maxheight>
  {#if option?.type === DropdownListType.Searchable}
    <SearchableList
      {maxheight}
      {list}
      placeholder={option?.searchPlaceholder}
      canCreate={!!option?.canCreate}
      canCreateOnInput={!!option?.canCreateOnInput}
      {listId}
      bind:this={searchableListElement}
      {onclick}
      {oncreate}
      {oninputcreate}
    />
  {:else}
    <List {list} {maxheight} {onclick} {onhighlight} {listId} bind:this={plainListElement} />
  {/if}
</div>

<style src="./DropdownList.css">
</style>
